import React from 'react';
import CSSZSickLeaveCertificateFormHeadline from './CSSZSickLeaveCertificateFormHeadline';
import Button from '../../../../../Components/Button/Button';
import { useDisclose } from '../../../../Modal/Hooks/useDisclose';
import CSSZSickLeavePatientAddressFormModal from '../../CSSZSickLeavePatientAddressForm/CSSZSickLeavePatientAddressFormModal';
import {
	CSSZSickLeaveValues,
	CSSZSubmitValues,
} from '../CSSZSickLeaveCertificateCreate';
import { CSSZAddress } from '../../../Interfaces/CSSZ.interface';
import { DeepPartial } from '../../../../../Interfaces/DeepPartial';
import { isCSSZAddressComplete } from '../../../Helpers/CSSZ.helper';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import styles from './CSSZSickLeaveCertificateFormPartB.module.scss';
import CSSZAddressPreview from './CSSZAddressPreview';

interface Props {
	patientId: string;
	onSubmit: (values: CSSZSubmitValues) => void;
	collectedValues?: DeepPartial<CSSZSickLeaveValues>;
}

const CSSZSickLeaveCertificateFormPartB: React.FC<Props> = ({
	patientId,
	onSubmit,
	collectedValues,
}) => {
	const { isOpen, onOpen, onClose } = useDisclose();

	const handleSubmit = (values: CSSZAddress) => {
		onSubmit({ type: 'patientAddress', data: values });
		onClose();
	};

	let content = (
		<Button
			title='component.CSSZSickLeaveCertificateFormPartB.entry'
			onClick={onOpen}
			fitContent
		/>
	);

	const address = collectedValues?.patientAddress;

	if (address && isCSSZAddressComplete(address)) {
		content = (
			<div className={styles.addressWrapper}>
				<CSSZAddressPreview address={address as CSSZAddress} />
				<LinkButton
					title='base.shared.edit'
					theme={Theme.BLUE}
					onClick={onOpen}
				/>
			</div>
		);
	}

	return (
		<>
			<CSSZSickLeaveCertificateFormHeadline title='component.CSSZSickLeaveCertificateFormPartB.title' />
			{content}
			{isOpen && (
				<CSSZSickLeavePatientAddressFormModal
					isOpen
					userId={patientId}
					onClose={onClose}
					onSubmit={handleSubmit}
					collectedValues={collectedValues}
				/>
			)}
		</>
	);
};

export default CSSZSickLeaveCertificateFormPartB;
